export enum AvailabilityOptionsForFixedBalance {
  AllDays = 'all_days',
  Daily = 'generated_days',
  Mensiversary = 'mensiversary',
  MonthlyLastDay = 'generated_days_monthly',
  MonthlyFirstDay = 'generated_days_monthly_first_day',
  MonthlyFifteenth = 'monthly_fifteenth',
  BimonthlyFirstAndFifteenth = 'bimonthly_first_and_fifteenth',
  BimonthlyFifteenthAndLast = 'bimonthly_fifteenth_and_last',
}

export enum AvailabilityOptionsForWorkedTime {
  AllDays = 'all_days',
  BimonthlyFirstAndFifteenth = 'bimonthly_first_and_fifteenth',
  BimonthlyFifteenthAndLast = 'bimonthly_fifteenth_and_last',
}

export enum TargetBalance {
  Available = 'available',
  Accrued = 'accrued',
}
